<v-last-viewed-clients-tabs :currentClientId="refundOrder?.clientId"></v-last-viewed-clients-tabs>

<v-alert v-model="showProcessAlert" :title="'refund_order.alert_process'" :text="'refund_order.process_alert_text'" :successButtonText="$t('refund_order.confirm')" :cancelButtonText="$t('refund_order.cancel')" @success="processRefundOrder" @cancel="showProcessAlert = false"></v-alert>
<v-alert v-model="showCancelAlert" :title="'refund_order.alert_cancel'" :text="'refund_order.cancel_alert_text'" :successButtonText="$t('refund_order.confirm')" :cancelButtonText="$t('refund_order.cancel')" @success="cancelRefundOrder" @cancel="showCancelAlert = false"></v-alert>

<div class="content_wrapper refund_order_wrapper">
    <v-client-tabs-menu :clientId="refundOrder?.clientId" activeTab="payment-info"></v-client-tabs-menu>
    <button @click="$router.push(`/client/${refundOrder?.clientId}/payment-info`)" class="button button_back" :disabled="!refundOrder?.clientId"><img class="back_button_img" src="/assets/img/arrow-left.svg"><span>{{$t('refund_order.payments')}}</span></button>
    <div class="refund_order_page_wrapper">
        <div class="refund_order_data">

            <div class="w-100 mb-1">
                <div class="refund_order_title">
                    <p class="refund_order" v-show="isLoaded">RORD #{{refundOrder?.refundOrderId?.toString().padStart(8, '0')}}</p>
                    <div :class="'refund_order_status status_text_' + refundOrderStatus" v-show="isLoaded">{{$t('refund_order_status.' + refundOrderStatus)}}</div>
                </div>

            </div>

            <div class="mt-3 refund_order_data_block">
                <p class="block_label">{{ $t('refund_order.amount') }}</p>
                <p class="block_info">{{ getFormatedAmount(refundOrder?.total) }} {{refundOrder?.currencySign }}</p>
            </div>

            <div class="mt-3 refund_order_data_block">
                <p class="block_label">{{ $t('refund_order.date') }}</p>
                <p class="block_info">{{ getFormatedDate(refundOrder?.dueDate, "DD.MM.yyyy") || '-' }}</p>
            </div>

            <div class="mt-3 refund_order_data_block">
                <p class="block_label">{{ $t('refund_order.description') }}</p>
                <p class="block_info">{{ refundOrder?.comment }}</p>
            </div>
        </div>

        <div class="button_wrapper">
            <button class="refund_order_process_button" v-if="refundOrder?.canBeProcessed && hasProcessPermission" @click="showProcessAlert = true" :disabled="isButtonDisabled">{{ $t('refund_order.process_refund_order') }}</button>
            <button class="refund_order_cancel_button" v-if="refundOrder?.processingStatus == 0 && hasCancelPermission" @click="showCancelAlert = true" :disabled="isButtonDisabled">{{ $t('refund_order.cancel_refund_order') }}</button>
        </div>

        <div class="refund_order_data mt-6">
            <div class="receipt_link_wrapper">
                <h3 class="my-0">{{$t('refund_order.refund_order_details')}}</h3>
                <a class="receipt_link" v-if="refundOrder?.receiptUrl" :href="refundOrder?.receiptUrl" target="_blank">{{$t('refund_order.open_receipt')}}</a>
            </div>

            <v-datatable class="mt-3" :columTemplates="refundOrderItemsColumTemplates" :data="refundOrderItemsTableData" :isLoading="!isLoaded"></v-datatable>
        </div>
    </div>

</div>

